<template>
	<div>
		<div class="btn btn-rounded theme" @click="googleButton">
			<img
				src="https://developers.google.com/identity/images/g-logo.png"
				style="height: 22px; width: 26px; padding-right: 4px;"
			/>
			Google Drive
		</div>
		<div v-if="isSignedIn" class="btn btn-rounded theme" @click="openPicker">New Picker</div>

		<google-drive-picker
			:visible="showPicker"
			:gapi="gapi"
			:refresh="refreshPicker"
			@closed="closePicker"
			@picked="pickedFolder"
		/>
	</div>
</template>

<style scoped>
</style>

<script>
import GoogleDrivePicker from "@/components/GoogleDrivePicker";
import ImageService from "@/services/ImageService";
import Notie from "@/services/NotieService";
import $ from "jquery";

export default {
	name: "GoogleApiRequest",
	props: ["value"],

	components: { GoogleDrivePicker },

	data() {
		return {
			gapi: gapi,
			clientId: "109067054622-6c8rot7llv7ba9v9nooe6k3shtbcpakh.apps.googleusercontent.com",
			apiKey: "AIzaSyC6DLT4E1MlrGsGhAkR1QxWjIExpgumKOU",
			appId: "109067054622",

			oauthToken: null,

			loading: false,
			GoogleAuth: null,
			isSignedIn: null,

			picker: null,

			showPicker: false,
			refreshPicker: null
		};
	},
	created() {
		gapi.load("client", () => {
			gapi.client
				.init({
					apiKey: this.apiKey,
					clientId: this.clientId,
					scope: "https://www.googleapis.com/auth/drive.metadata.readonly",
					discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"]
				})
				.then(resp => {
					console.log("load response", resp);
					this.GoogleAuth = gapi.auth2.getAuthInstance();

					this.isSignedIn = this.GoogleAuth.isSignedIn.get();

					this.GoogleAuth.isSignedIn.listen(this.updateSigninStatus);
				})
				.catch(err => {
					console.log(err);
				});
		});
	},
	watch: {},

	computed: {},

	methods: {
		closePicker() {
			console.log("got close event");
			this.showPicker = false;
		},

		pickedFolder(folder) {
			console.log("got picked event", folder);
			this.showPicker = false;
		},

		googleButton() {
			if (this.isSignedIn) {
				gapi.load("picker", { callback: this.createPicker });
				gapi.load("auth", {
					callback: () => {
						gapi.auth.authorize(
							{
								client_id: this.clientId,
								scope: ["https://www.googleapis.com/auth/drive"],
								immediate: false
							},
							result => {
								if (result && !result.error) {
									this.oauthToken = result.access_token;
									this.createPicker();
								}
							}
						);
					}
				});
			} else {
				this.signIn();
			}
		},

		onAuthApiLoad() {},

		createPicker() {
			var docsView = new google.picker.DocsView()
				.setIncludeFolders(true)
				.setMimeTypes("application/vnd.google-apps.folder")
				.setSelectFolderEnabled(true);
			var picker = new google.picker.PickerBuilder()
				.enableFeature(google.picker.Feature.NAV_HIDDEN)
				.enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
				.setOAuthToken(this.oauthToken)
				.setDeveloperKey(this.apiKey)
				.addView(docsView)
				.addView(new google.picker.DocsUploadView())
				.setCallback(this.pickerCallback)
				.build();
			picker.setVisible(true);
			this.picker = picker;

			console.log(picker);
		},

		pickerCallback(data) {
			console.log("Picker callback", data);
			if (data.action == "picked") {
				this.requestFiles(data.docs[0].id);
				this.picker.setVisible(false);
			}
		},

		signIn() {
			console.log("Sign in");
			if (!this.isSignedIn) {
				this.GoogleAuth.signIn();
			}
		},

		updateSigninStatus(isSignedIn) {
			console.log("updateSigninStatus", isSignedIn);
			if (isSignedIn) {
				this.isAuthorized = true;
				this.requestFiles();
			} else {
				this.isAuthorized = false;
			}
		},

		requestFiles(id) {
			console.log("REQUESTING FILES");
			var request = gapi.client.request({
				method: "GET",
				path: "/drive/v3/files",
				params: {
					q: `'${id}' in parents`
				}
			});
			// Execute the API request.
			request.execute(resp => {
				console.log("FILES", resp.files);
				this.$emit("update:files", resp.files);
			});
		},

		openPicker() {
			this.showPicker = true;
			this.refreshPicker = new Date();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/GoogleApiRequest.vue